import React from 'react';
import { Formik, Form } from 'formik';
import { ChangeYourPasswordSchema } from '../../../schemas';
import { PrimaryButton } from "../../UI";
import { FormikInput } from '../Formik';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const ChangeYourPasswordForm = (submitHandler) => {
    const { content } = useContentfulContext();

    return (
        <Formik
            initialValues={{
                currentPassword: '',
                newPassword: '',
                confirmPassword: ''
            }}
            validationSchema={() => ChangeYourPasswordSchema(content.CHANGE_YOUR_PASSWORD_CONTENT)}
            onSubmit={async () => {
                if (typeof submitHandler === 'function') {
                    submitHandler();
                }
            }}
        >
            {() => (
                <Form className="space-y-4 md:space-y-6" action="#" id="change-password-form">
                    <FormikInput
                        type="password"
                        name="currentPassword"
                        id="currentPassword"
                        label={content.CHANGE_YOUR_PASSWORD_CONTENT.formLabels.current_password}
                        placeholder="••••••••"
                    />
                    <FormikInput
                        type="password"
                        name="newPassword"
                        id="newPassword"
                        label={content.CHANGE_YOUR_PASSWORD_CONTENT.formLabels.new_password}
                        placeholder="••••••••"
                    />
                    <FormikInput
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        label={content.CHANGE_YOUR_PASSWORD_CONTENT.formLabels.confirm_password}
                        placeholder="••••••••"
                    />
                    <div className="mb-4">
                        <PrimaryButton type="submit">{content.CHANGE_YOUR_PASSWORD_CONTENT.formLabels.cta_text}</PrimaryButton>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default ChangeYourPasswordForm;
